/* First argument is an array of all the setter functions that take a boolean to turn the flag on show or not show their content. The second argument is also a setter that we have to set to true. So turn ALL flags to false and then turn only one to true */
export default function setAllFlagsOff(offArray, onOne) {
  for (let i = 0; i < offArray.length; i++) {
    offArray[i](false);
  }
  onOne(true);
}
